'use client';

import { useKlaviyo } from '@/hooks';
import { useUser } from '@skin-seoul/service';
import { useEffect } from 'react';
const KlaviyoIdentify = () => {
  const {
    identify
  } = useKlaviyo();
  const {
    user
  } = useUser();
  useEffect(() => {
    identify({
      ...user
    });
  }, [identify, user]);
  return null;
};
export default KlaviyoIdentify;